<div class="tyalls-table-name mb-3">
	<h6 class="tyalls-table-heading">Active Features &amp; Access</h6>
</div>

<div class="panel">
	<div class="panel-actions">
		<button pButton type="button" label="Download" (click)="download.emit()"></button>
	</div>

	<!-- Two columns now -->
	<div class="access-grid">
		<!-- Left -->
		<div class="col">
			<div class="row">
				<div class="meta">
					<div class="meta-label">
						Group Details:
						<span class="count-badge" *ngIf="!isListsLoading">{{ noActiveGroups }}</span>
					</div>
				</div>

				<div class="list-box">
					<ng-container *ngIf="!isListsLoading; else loadingGroups">
						<div *ngIf="activeGroups?.length; else noGroups" class="list">
							<div *ngFor="let g of activeGroups; trackBy: trackByIndex" class="list-item">{{ g }}</div>
						</div>
					</ng-container>
					<ng-template #loadingGroups><div class="placeholder">Loading…</div></ng-template>
					<ng-template #noGroups><div class="placeholder">No groups</div></ng-template>
				</div>
			</div>

			<div class="row">
				<div class="meta">
					<div class="meta-label">
						Active Users:
						<span class="count-badge" *ngIf="!isListsLoading">{{ noActiveUsers }}</span>
					</div>
				</div>

				<div class="list-box">
					<ng-container *ngIf="!isListsLoading; else loadingUsers">
						<div *ngIf="activeUsers?.length; else noUsers" class="list">
							<div *ngFor="let u of activeUsers; trackBy: trackByIndex" class="list-item">{{ u }}</div>
						</div>
					</ng-container>
					<ng-template #loadingUsers><div class="placeholder">Loading…</div></ng-template>
					<ng-template #noUsers><div class="placeholder">No active users</div></ng-template>
				</div>
			</div>
		</div>

		<!-- Right -->
		<div class="col">
			<div class="row">
				<div class="meta">
					<div class="meta-label">
						AI Tasks Activated:
						<span class="count-badge" *ngIf="!isAiActivatedTasksLoading">{{ aiTasksActivatedCount }}</span>
					</div>
				</div>

				<div class="list-box">
					<ng-container *ngIf="!isAiActivatedTasksLoading; else loadingAi">
						<div *ngIf="aiTasksActivated?.length; else noAi" class="list">
							<div *ngFor="let t of aiTasksActivated; trackBy: trackByIndex" class="list-item">{{ t }}</div>
						</div>
					</ng-container>
					<ng-template #loadingAi><div class="placeholder">Loading AI enabled tasks…</div></ng-template>
					<ng-template #noAi><div class="placeholder">No AI tasks enabled</div></ng-template>
				</div>
			</div>

			<div class="row">
				<div class="meta">
					<div class="meta-label">Add-On Features:</div>
				</div>

				<div class="list-box">
					<div class="list">
						<div *ngFor="let a of addOns; trackBy: trackByIndex" class="list-item">{{ a }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
